import axios from "../axios/index.js";

const urlGetMaterialTypeList = "/api/material/type/get-list";
const urlGetListWithoutPaginate = "/api/material/type/get-list-without-paginate";
const urlCreateMaterialType = "/api/material/type/create";
const urlUpdateMaterialType = "/api/material/type/update/";
const urlGetMaterialTypeSlug = "/api/material/type/check-slug";
const urlGetMaterialTypeDetail = "/api/material/type/detail/";
const urlDeleteColor = "/api/material/type/delete/";

export default {
    getList(params) {
        return axios.get(urlGetMaterialTypeList, { 
            params: params
        });
    },

    getListWithoutPaginate() {
        return axios.post(urlGetListWithoutPaginate);
    },

    getDetail(id) {
        return axios.get(urlGetMaterialTypeDetail + id);
    },

    create(params) {
        return axios.post(urlCreateMaterialType, params);
    },

    update(params) {
        return axios.post(urlUpdateMaterialType + params.id, params);
    },

    getSlug(params) {
        return axios.post(urlGetMaterialTypeSlug, params);
    },

    delete(id) {
        return axios.post(urlDeleteColor + id, id);
    },
};
